package demos.buttons

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.LocalContentColor
import androidx.compose.material.LocalTextStyle
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp


const val GLOW_BUTTON = "b483c1e7c6473f1a4b3df3144e1177d65d78979706640e5be67ee90187a0426b"


@Composable
fun GlowButton() {
    var touched by remember { mutableStateOf(false) }
    val yellow = remember { Color(0xFFede342) }
    val pink = remember { Color(0xFFff51eb) }

    val startColor by animateColorAsState(
        targetValue = if (touched) yellow else pink,
        animationSpec = tween(500)
    )

    val endColor by animateColorAsState(
        targetValue = if (touched) pink else yellow,
        animationSpec = tween(500)
    )

    val scale by animateFloatAsState(
        targetValue = if (touched) .9f else 1f, animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMediumLow
        )
    )

    Box(
        modifier = Modifier
            .padding(4.dp)
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        touched = true
                        awaitRelease()
                        touched = false
                    }
                )
            }
            .shadow(
                elevation = 40.dp,
                shape = CircleShape,
                clip = false,
                ambientColor = startColor,
                spotColor = endColor,
            )
            .scale(scale)
            .background(
                Color.Black,
                CircleShape
            )
            .border(
                1.dp,
                brush = Brush.linearGradient(
                    listOf(
                        startColor,
                        endColor
                    ),
                    Offset(0.0f, 0.0f), Offset(Float.POSITIVE_INFINITY, Float.POSITIVE_INFINITY)
                ),
                shape = CircleShape,
            )
            .padding(horizontal = 24.dp, vertical = 8.dp)
    ) {
        CompositionLocalProvider(
            LocalContentColor provides Color.White,
            LocalTextStyle provides TextStyle(
                fontWeight = FontWeight.Medium,
            ),
        ) {
            Text(text = "Glow Button")
        }
    }
}